import { useEffect } from "react";
import { TopBar } from "@/components/TopBar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Toolkits } from "@/components/Toolkits";
import { PartnerLinks } from "@/components/PartnerLinks";
import { ToolkitOne } from "@/components/tools/ToolkitOne";
import { Feedback } from "@/components/Feedback";
import { Footer } from "@/components/Footer";
import { scrollToId } from "@/lib/scroll";
import { toast } from "sonner";

const useFeedbackPrompt = () => {
  useEffect(() => {
    const ask = () => toast("Thank you for using this resource", {
      description: "Could you spare a minute to tell us what helped?",
      duration: 12000,
      action: { label: "Give feedback", onClick: () => scrollToId("feedback") },
    });
    window.addEventListener("sap:exported", ask);
    return () => window.removeEventListener("sap:exported", ask);
  }, []);
};

export default function Landing() {
  useFeedbackPrompt();
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return undefined;
    const t = setTimeout(() => scrollToId(id), 400);
    return () => clearTimeout(t);
  }, []);
  return (
    <>
      <TopBar />
      <main id="main" tabIndex={-1} className="outline-none">
        <Hero />
        <Marquee />
        <Toolkits />
        <PartnerLinks />
        <ToolkitOne />
        <Feedback />
      </main>
      <Footer />
    </>
  );
}
